/**
 * Created by superman on 17/2/16.
 * http配置
 */

import axios from "axios";
import router from "./router/index.js";
import { Message } from "element-ui";
import store from "./store/store.js";

// axios 配置
// axios.defaults.timeout = 5000
// axios.defaults.baseURL = 'https://api.github.com'

/**
router.beforeEach((to, from, next) => {
  if (to.path=="/login") {  // 判断该路由是否需要登录权限
      next();
   }
  else {

    if(sessionStorage.getItem("token")!=null&&sessionStorage.getItem("uuid")!=null){
      if(to.path=="/index"){
        next();
      }else{  


            axios.post(store.state.loginHttp2+store.state.loginPort2+'/selectMenu'
            ).then(response=>{
                for(var j = 0; j < response.data.length; j++){
                  var yz=false;
                  for(var k = 0; k <  router.options.routes[0].children[1].children.length; k++){
                        if( router.options.routes[0].children[1].children[k].path=='/ldjsc/'+response.data[j]){
                         yz=true;
                         break;
                        }
                  }
                  if(!yz){
                    router.options.routes[0].children[1].children.push({path: '/ldjsc/'+response.data[j],title:response.data[j],component:() => import('@/components/ldjsc/charttest.vue')})
                  }
                }
                yz=false;
                for (let index = 0; index < router.options.routes[0].children.length; index++) {
                const element = router.options.routes[0].children[index];
                var routeObj=catchRouter(element,to.path);
                if(routeObj!=null){
                  yz=true;
                  //接口验证
                  var params = new URLSearchParams();
                  params.append('title',routeObj.title); 
                  axios.post(store.state.loginHttp2+store.state.loginPort2+'/selectMenuByUseIdr',params
                  ).then(response=>{
                      if(response.data){
                          next();
                      }else{
                        next({
                          path: '/index',
                        })
                        Message.error({
                          duration:1000,
                          message: '您没有访问权限'
                      })
                      }
                  })
                  break;
                 }
              }
              if(!yz){
                next({
                      path: '/index',
                    })
                      Message.error({
                        duration:1000,
                        message: '您访问的地址不存在'
                    })
              }
            })
           
      }

    }else{
      next({
        path: '/login',
      })
    }
  }
})
*/
function catchRouter(obj, p) {
    if (obj.children && obj.children.length > 0) {
        for (let i = 0; i < obj.children.length; i++) {
            const element = obj.children[i];
            let o = catchRouter(element, p);
            if (o != null) {
                return o;
            }
        }
    } else {
        if (obj.path == p) {
            return obj;
        }
    }
}
//http request 拦截器

axios.interceptors.request.use(
    (config) => {
        // config.headers.token = `${sessionStorage.getItem("token")}`;
        //    config.headers.uuid = `${sessionStorage.getItem("uuid")}`;
        if (sessionStorage.getItem("dytoken")) {
            config.headers.token = `${sessionStorage.getItem("dytoken")}`;
            config.headers.uuid = `${sessionStorage.getItem("dyuuid")}`;
        } 
        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);
let ll = false;
// http 拦截器response
axios.interceptors.response.use(
    (response) => {
        ll = false; 
        let res = response.data;
        if (response.status === 200 && res.code) { 
                if (res.code !== 200) { 
                    if (res.code === "20202") { 
                        sessionStorage.removeItem("dytoken");
                        sessionStorage.removeItem("dyuuid");
                        router.push({ path: "/login" });
                        return;
                        // location.reload()
                    }
                }
        }
        return response;
    },
    (error) => {
        console.log("错误信息");
        console.log(error);
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    if (!ll) {
                        Message.error({
                            duration: 1000,
                            message: "登录超时请重新登录!",
                        });
                        ll = true;
                    }
                    // 401 清除token信息并跳转到登录页面
                    sessionStorage.removeItem("dytoken");
                    sessionStorage.removeItem("dyuuid");
                    // 只有在当前路由不是登录页面才跳转
                    router.push({ path: "/login" });
                    return;
            }
        }
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        // return Promise.reject(error.response.data)
    }
);
export default axios;



// WEBPACK FOOTER //
// ./src/http.js